import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import {
  MARKET_GROUP_TYPES,
  MARKET_TYPES,
  WIN_COMBINATIONS,
  WIN_COMBINATIONS_NAMES,
} from '../../enums/betTypesEnum';
import BetChipSection from '../betChipSection';
import { gameStore } from '../../store/gameStore';
import { ExtraBetsOddSection } from '../extraBetsOddSection';
import { winningAmountStore } from '../../store/winningAmountStore';

const firstColumn = [
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.RoyalFlush],
    cards: ['h-A', 'h-K', 'h-Q', 'h-J', 'h-10'],
    id: 1,
    marketType: MARKET_TYPES.RoyalFlush,
    winCombination: WIN_COMBINATIONS.RoyalFlush,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.StraightFlush],
    cards: ['c-4', 'c-5', 'c-6', 'c-7', 'c-8'],
    id: 2,
    marketType: MARKET_TYPES.StraighFlush,
    winCombination: WIN_COMBINATIONS.StraightFlush,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.FourOfKind],
    cards: ['h-10', 'h-7', 'p-7', 'd-7', 'c-7'],
    disabledIndex: [0],
    id: 3,
    marketType: MARKET_TYPES.FourOfKind,
    winCombination: WIN_COMBINATIONS.FourOfKind,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.FullHouse],
    cards: ['h-J', 'c-J', 'h-K', 'p-K', 'd-K'],
    id: 4,
    marketType: MARKET_TYPES.FullHouse,
    winCombination: WIN_COMBINATIONS.FullHouse,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.Flush],
    cards: ['h-6', 'h-8', 'h-Q', 'h-3', 'h-10'],
    id: 5,
    marketType: MARKET_TYPES.Flush,
    winCombination: WIN_COMBINATIONS.Flush,
  },
];
const secondColumn = [
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.Straight],
    cards: ['p-6', 'h-7', 'c-8', 'd-9', 'p-10'],
    id: 1,
    marketType: MARKET_TYPES.Straight,
    winCombination: WIN_COMBINATIONS.Straight,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.ThreeOfKind],
    cards: ['h-7', 'c-3', 'h-K', 'p-K', 'd-K'],
    disabledIndex: [0, 1],
    id: 2,
    marketType: MARKET_TYPES.ThreeOfKind,
    winCombination: WIN_COMBINATIONS.ThreeOfKind,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.TwoPairs],
    cards: ['h-Q', 'c-4', 'h-4', 'c-A', 'h-A'],
    disabledIndex: [0],
    id: 3,
    marketType: MARKET_TYPES.TwoPairs,
    winCombination: WIN_COMBINATIONS.TwoPairs,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.OnePair],
    cards: ['h-6', 'd-8', 'h-Q', 'p-5', 'h-5'],
    disabledIndex: [0, 1, 2],
    id: 4,
    marketType: MARKET_TYPES.OnePair,
    winCombination: WIN_COMBINATIONS.OnePair,
  },
  {
    name: WIN_COMBINATIONS_NAMES[WIN_COMBINATIONS.HighCard],
    cards: ['p-2', 'c-4', 'd-8', 'h-7', 'h-A'],
    disabledIndex: [0, 1, 2, 3],
    id: 5,
    marketType: MARKET_TYPES.HighCard,
    winCombination: WIN_COMBINATIONS.HighCard,
  },
];
const allColumns = [firstColumn, secondColumn];

export const CombinationBets = observer(({ handleDoChip }) => {
  const { roundBetTypesInfo } = gameStore;
  const { winningCombination } = winningAmountStore;
  const t = useTranslation();

  const combinationBetTypesInfo = useMemo(() => {
    if (roundBetTypesInfo) {
      return roundBetTypesInfo.find(
        (item) => item.groupType === MARKET_GROUP_TYPES.WinningCombination
      );
    }
    return null;
  }, [roundBetTypesInfo]);

  const handleIsAllowDoChip = useCallback(
    (data) => {
      const combinationInfo = combinationBetTypesInfo?.selections?.find(
        (item) => item.marketType === data.betType
      );
      if (combinationInfo?.hasOwnProperty('odd') && combinationInfo.odd <= 1) {
        return;
      }
      handleDoChip(data);
    },
    [combinationBetTypesInfo, handleDoChip]
  );

  return (
    <div className='combinations-cont-wrapper'>
      {allColumns.map((columnData, index) => (
        <div key={'column'.concat(`${index}`)} className='column-combinations'>
          {columnData.map(({ name, cards, id, disabledIndex, marketType }) => (
            <div className='combinations-row' key={id}>
              <div className='combinations-row-inner'>
                <p className='combinations-name-title'>{t(name)}</p>
                <div className='combinations-cards-cont'>
                  {/* TODO wait cards */}
                  {/* ADD class " disabled " */}
                  {cards.map((card, i) => (
                    <div
                      key={`${card}`.concat(`${i}`)}
                      className={`combinations-cards-small-boxes card-deck-2 ${card} ${
                        disabledIndex?.includes(i) ? 'disabled' : ''
                      }`}
                    />
                  ))}
                </div>
              </div>
              <div
                className='combinations-row-inner'
                onClick={() =>
                  handleIsAllowDoChip({
                    betType: marketType,
                    groupType: MARKET_GROUP_TYPES.WinningCombination,
                  })
                }
              >
                <ExtraBetsOddSection
                  isOddLose={Number.isInteger(winningCombination)}
                  currentSelection={combinationBetTypesInfo?.selections?.find(
                    (item) => item.marketType === marketType
                  )}
                />
                <BetChipSection
                  isLittleChip
                  betType={marketType}
                  groupType={MARKET_GROUP_TYPES.WinningCombination}
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
});
